/* Court Vibes: Verhalten nach dem Hinzufuegen in den Warenkorb.
   Stand 18.09.2026, dritte Fassung.

   Ziel, von Houda am 18.09.2026 formuliert: nach dem Hinzufuegen soll KEIN
   Warenkorb aufklappen, sondern eine gruene Meldung unter dem Kaufknopf
   stehen, und diese Meldung soll nach kurzer Zeit wieder verschwinden.
   Personalisierte und nicht personalisierte Produktseiten sollen sich dabei
   gleich verhalten.

   WAS AM 18.09.2026 GEMESSEN WURDE, nicht vermutet:

   1) Auf einer nicht personalisierten Seite erscheint die eigene Meldung
      zuverlaessig, sobald der Mobilzweig greift. Nachgestellt auf
      /products/meine-melodie-t-shirt: Meldung vorhanden, Schubfach zu,
      Warenkorbzahl auf 5 gestiegen. Der Code war also nicht kaputt, er lief
      nur nicht: die alte Fassung hatte die Bedingung istMobil() davor, am
      Rechner wurde deshalb gar keine Meldung gezeigt und das Schubfach ging
      auf. Genau das hat Houda als Unterschied gesehen. Die Bedingung ist
      hier entfallen, das Verhalten ist auf allen Geraeten gleich.

   2) Diese Seiten haben zusaetzlich einen zweiten Kaufknopf:
      <sticky-add-to-cart> mit .sticky-add-to-cart__bar, position fixed,
      74 Pixel hoch, blendet sich beim Scrollen unten ein. Auch dieser Knopf
      traegt die Klasse .add-to-cart-button. Wer ihn benutzt, hat den
      Hauptknopf laengst aus dem Bild gescrollt, eine Meldung dort waere
      unsichtbar. Deshalb merkt sich diese Datei, welcher Knopf wirklich
      angetippt wurde, und setzt die Meldung ueber den eingeblendeten
      Balken, wenn es der untere war.

   3) Die Meldung, die auf personalisierten Seiten stehen blieb, ist NICHT
      die eigene. Sie gehoert teeinblue und steckt in
      .tee-form-responses > .tee-success > .tee-response. teeinblue raeumt
      sie nie ab, auch nicht beim Wechsel von L auf XL. Deshalb bekommt sie
      hier eine Standzeit und wird beim naechsten Handgriff des Kunden
      ausgeblendet.

   WARUM teeinblues Meldung nur AUSGEBLENDET und nicht geloescht wird:
   teeinblue koennte sich die Knoten merken und beim naechsten Hinzufuegen
   nur den Text tauschen. Wer sie loescht, riskiert, dass beim zweiten Kauf
   gar keine Meldung mehr kommt. Eine Klasse am Behaelter ist umkehrbar, sie
   wird vor jedem neuen Kauf wieder entfernt.

   ZUM SCHUBFACH: Horizon registriert <cart-drawer-component> mit open().
   In assets/cart-drawer.js nachgelesen: open() ruft NUR showDialog(). Es
   aktualisiert weder die Zahl am Warenkorbsymbol noch loest es ein Bildchen
   aus, beides haengt am Ereignis cart:add. Diese Bremse kann also keine Zahl
   verschlucken. open() wird aber auch benutzt, wenn jemand oben auf das
   Warenkorbsymbol tippt, das MUSS weiter oeffnen, erkannt an event.isTrusted.

   Auf personalisierten Seiten baut teeinblue sein eigenes Kaufformular, der
   Klick laeuft NICHT ueber die Theme-Knoepfe. Deshalb wird zusaetzlich fetch
   und XMLHttpRequest abgehoert: jede Anfrage an /cart/add meldet einen Kauf.

   Mitgeschrieben am 18.09.2026, Millisekunden ab Seitenstart:
       92205  Anfrage an /cart/add.js
       92888  Antwort da
       95574  open() wird gerufen
   2686 ms zwischen Antwort und Oeffnen. Eine feste Frist von 2500 ms war zu
   kurz, bei erhoehter Menge ging das Schubfach doch auf. Deshalb: Erwartung
   8 Sekunden, 1,5 Sekunden Nachlauf, ein Kauf ruft open() zweimal in
   derselben Millisekunde.

   NIE WIEDER, am 18.09.2026 teuer gelernt: nicht in connectedCallback von
   fly-to-cart eingreifen. Das setzt mitten in der Kette an, die nach dem
   Hinzufuegen laeuft, danach zaehlte die Warenkorbzahl nicht mehr hoch.

   Das fliegende Bildchen steht NICHT hier, es hat eine eigene Datei:
   assets/cv-flug.js.

   Faellt die Datei aus, ist wieder alles wie im Theme vorgesehen.
   Pruefen: window.CV_TOAST_AKTIV muss true sein. */

(function () {
  var ERWARTUNG = 8000;
  var NACHLAUF = 1500;
  var TIPP_FENSTER = 1200;
  var STEHZEIT = 6000;
  var SCHONFRIST = 700;
  var ABSTAND = 10;
  var SUCHDAUER = 9000;
  var SUCHTAKT = 200;

  var erwarte = false;
  var erwarteTimer = null;
  var nachlaufBis = 0;
  var letzterTipp = 0;
  var timer = null;
  var letzterKnopf = null;
  var zeigtSeit = 0;
  var teeTimer = null;
  var teeSuche = null;

  /* ---------- kleine Helfer ---------- */

  function merkeKauf() {
    erwarte = true;
    clearTimeout(erwarteTimer);
    erwarteTimer = setTimeout(function () {
      erwarte = false;
    }, ERWARTUNG);
    if (hatTeeinblue()) teeBeobachten();
  }

  function nutzerWillSchubfach() {
    return Date.now() - letzterTipp < TIPP_FENSTER;
  }

  function hatTeeinblue() {
    return !!document.querySelector('.tee-customize-main-form, .tee-customization-form');
  }

  function sichtbar(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function stickyBalken() {
    return document.querySelector('.sticky-add-to-cart__bar');
  }

  function kaufbereich() {
    var root = document.querySelector("[id^='ProductInformation']") || document;
    return root.querySelector('.product-form-buttons');
  }

  function anker(box) {
    var knopf = box.querySelector('.add-to-cart-button');
    if (!knopf) return null;
    var kind = knopf;
    while (kind && kind.parentElement && kind.parentElement !== box) {
      kind = kind.parentElement;
    }
    return kind && kind.parentElement === box ? kind : null;
  }

  function kopfUnterkante() {
    var kandidaten = ['header-component', '#header-group', '.header-section'];
    var beste = 0;
    for (var i = 0; i < kandidaten.length; i++) {
      var el = document.querySelector(kandidaten[i]);
      if (!el) continue;
      var unten = el.getBoundingClientRect().bottom;
      if (unten > beste) beste = unten;
    }
    if (beste < 0) beste = 0;
    return beste || 110;
  }

  /* ---------- die eigene Meldung ---------- */

  function meldungBauen() {
    var d = document.createElement('div');
    d.className = 'cv-kauf-hinweis';
    d.setAttribute('role', 'status');
    d.setAttribute('aria-live', 'polite');
    d.innerHTML =
      '<span class="cv-kauf-hinweis__zeile">' +
      '<svg class="cv-kauf-hinweis__haken" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="9.2" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M7.8 12.3l2.8 2.8 5.6-5.8" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      'Dieser Artikel wurde zum Warenkorb hinzugefügt!</span>' +
      '<a class="cv-kauf-hinweis__link" href="/cart">Warenkorb ansehen</a>';
    return d;
  }

  function standzeitSetzen(d) {
    zeigtSeit = Date.now();
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      if (d.parentNode) d.remove();
    }, STEHZEIT);
  }

  function hinweisUnten(nachElement) {
    var d = meldungBauen();
    nachElement.insertAdjacentElement('afterend', d);
    standzeitSetzen(d);
  }

  /* Freischwebende Fassung, wenn der Kaufknopf nicht im Bild ist. Sie setzt
     sich ueber den eingeblendeten Kaufbalken, sonst an den unteren Rand. */
  function hinweisSchwebend() {
    var d = meldungBauen();
    d.classList.add('cv-kauf-hinweis--fest');
    var balken = stickyBalken();
    var unten = 16;
    if (sichtbar(balken)) {
      unten = Math.round(window.innerHeight - balken.getBoundingClientRect().top + 8);
    }
    d.style.bottom = unten + 'px';
    document.body.appendChild(d);
    standzeitSetzen(d);
  }

  /* Letzte Rueckfallebene: es gibt gar keinen Kaufbereich, etwa auf einer
     Kollektionsseite mit Schnellkauf. Dann der alte Streifen unter dem Kopf. */
  function hinweisOben() {
    var box = document.createElement('div');
    box.className = 'cv-toast';
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    box.style.top = Math.round(kopfUnterkante() + ABSTAND) + 'px';

    var text = document.createElement('span');
    text.className = 'cv-toast__text';
    text.textContent = 'In den Warenkorb gelegt';

    var link = document.createElement('a');
    link.className = 'cv-toast__link';
    link.href = '/cart';
    link.textContent = 'Warenkorb ansehen';

    box.appendChild(text);
    box.appendChild(link);
    document.body.appendChild(box);

    zeigtSeit = Date.now();
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      box.classList.add('cv-toast--weg');
      setTimeout(function () {
        if (box.parentNode) box.remove();
      }, 300);
    }, STEHZEIT);
  }

  function hinweisZeigen() {
    eigeneMeldungWeg();

    var amBalken = !!(letzterKnopf && letzterKnopf.closest && letzterKnopf.closest('.sticky-add-to-cart'));
    if (amBalken && sichtbar(stickyBalken())) {
      hinweisSchwebend();
      return;
    }

    var box = kaufbereich();
    var ziel = box ? anker(box) : null;
    if (ziel && sichtbar(ziel)) {
      hinweisUnten(ziel);
      return;
    }
    if (ziel || sichtbar(stickyBalken())) {
      hinweisSchwebend();
      return;
    }
    hinweisOben();
  }

  function eigeneMeldungWeg() {
    var a = document.querySelector('.cv-kauf-hinweis');
    if (a) a.remove();
    var b = document.querySelector('.cv-toast');
    if (b) b.remove();
    if (timer) clearTimeout(timer);
  }

  /* ---------- teeinblues eigene Meldung baendigen ---------- */

  function teeBehaelter() {
    return document.querySelector('.tee-form-responses');
  }

  function teeZeigen() {
    var b = teeBehaelter();
    if (b) b.classList.remove('cv-tee-weg');
  }

  function teeVerstecken() {
    var b = teeBehaelter();
    if (b) b.classList.add('cv-tee-weg');
  }

  /* Wartet, bis teeinblue seine Meldung wirklich geschrieben hat, und gibt
     ihr dann dieselbe Standzeit wie der eigenen. Ohne dieses Warten wuerde
     die Uhr schon bei der Anfrage laufen, die Meldung kommt aber erst mit
     der Antwort. */
  function teeBeobachten() {
    teeZeigen();
    clearTimeout(teeTimer);
    clearInterval(teeSuche);
    var bis = Date.now() + SUCHDAUER;
    teeSuche = setInterval(function () {
      var b = teeBehaelter();
      var da = b && b.querySelector('.tee-success, .tee-response');
      if (da) {
        clearInterval(teeSuche);
        teeTimer = setTimeout(teeVerstecken, STEHZEIT);
        return;
      }
      if (Date.now() > bis) clearInterval(teeSuche);
    }, SUCHTAKT);
  }

  /* ---------- aufraeumen, sobald der Kunde weitermacht ---------- */

  function aufraeumen() {
    if (Date.now() - zeigtSeit < SCHONFRIST) return;
    eigeneMeldungWeg();
    clearTimeout(teeTimer);
    clearInterval(teeSuche);
    teeVerstecken();
  }

  document.addEventListener('change', aufraeumen, true);

  document.addEventListener(
    'click',
    function (e) {
      if (!e.isTrusted || !e.target || !e.target.closest) return;

      var kaufknopf = e.target.closest('.add-to-cart-button, .tee-btn--atc');
      if (kaufknopf) {
        letzterKnopf = kaufknopf;
        teeZeigen();
        return;
      }

      var traeger = e.target.closest('cart-icon, .header-actions__cart-icon, a[href$="/cart"]');
      if (traeger) {
        letzterTipp = Date.now();
        return;
      }

      /* Jeder andere Handgriff im Kaufbereich, etwa L auf XL oder die Menge,
         raeumt eine stehengebliebene Meldung ab. */
      if (e.target.closest("[id^='ProductInformation'], .tee-customize-main-form, .tee-customization-form, .sticky-add-to-cart")) {
        aufraeumen();
      }
    },
    true
  );

  /* ---------- Kauf erkennen ---------- */

  function patchen(name, methode) {
    if (!window.customElements) return;
    customElements.whenDefined(name).then(function () {
      var Klasse = customElements.get(name);
      if (!Klasse || !Klasse.prototype || !Klasse.prototype[methode]) return;
      var original = Klasse.prototype[methode];
      Klasse.prototype[methode] = function () {
        merkeKauf();
        return original.apply(this, arguments);
      };
    });
  }

  patchen('add-to-cart-component', 'handleClick');
  patchen('product-form-component', 'handleSubmit');

  function istZugabe(adresse) {
    return String(adresse).indexOf('/cart/add') > -1;
  }

  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var ziel = arguments[0];
      var adresse = ziel && ziel.url ? ziel.url : ziel;
      if (istZugabe(adresse)) {
        merkeKauf();
        var p = originalFetch.apply(this, arguments);
        try {
          p.then(
            function (a) {
              merkeKauf();
              return a;
            },
            function () {}
          );
        } catch (e) {}
        return p;
      }
      return originalFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest && XMLHttpRequest.prototype && XMLHttpRequest.prototype.open) {
    var originalOeffnen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, adresse) {
      try {
        if (istZugabe(adresse)) {
          merkeKauf();
          this.addEventListener('load', merkeKauf);
        }
      } catch (e) {}
      return originalOeffnen.apply(this, arguments);
    };
  }

  /* ---------- das Schubfach anhalten ---------- */

  if (window.customElements) {
    customElements.whenDefined('cart-drawer-component').then(function () {
      var Klasse = customElements.get('cart-drawer-component');
      if (!Klasse || !Klasse.prototype || !Klasse.prototype.open) return;
      var originalOpen = Klasse.prototype.open;
      Klasse.prototype.open = function () {
        var jetzt = Date.now();
        var imNachlauf = jetzt < nachlaufBis;

        if (!nutzerWillSchubfach() && (erwarte || imNachlauf)) {
          /* Ergaenzt am 27.10.2026: auf teeinblue-Seiten uebernimmt sonst
             teeinblues eigene Meldung. Bei Kampagnen ueber bestehende
             Shopify-Produkte (Snapwear-Tasse) rendert teeinblue aber weder
             Kaufknopf noch Meldung, gemessen am 27.10.2026 auf
             /products/tennis-mama-tasse-1: Warenkorbzahl stieg, keine
             Meldung. Deshalb zeigt die eigene Meldung auch dann, wenn zwar
             ein teeinblue-Formular, aber kein teeinblue-Kaufknopf da ist.
             Gesucht wird nur der Knopf im Formular, nicht der im
             Vorschau-Popup, das auch auf diesen Seiten einen hat. */
          var teeOhneKnopf = hatTeeinblue() && !document.querySelector('.tee-form-atc-wrapper .tee-btn--atc');
          if (!imNachlauf && (!hatTeeinblue() || teeOhneKnopf)) hinweisZeigen();
          nachlaufBis = jetzt + NACHLAUF;
          erwarte = false;
          clearTimeout(erwarteTimer);
          return;
        }
        return originalOpen.apply(this, arguments);
      };
      window.CV_TOAST_AKTIV = true;
    });
  }
})();